import { render, staticRenderFns } from "./marketingReason.vue?vue&type=template&id=7d28569e&scoped=true&"
import script from "./marketingReason.vue?vue&type=script&lang=js&"
export * from "./marketingReason.vue?vue&type=script&lang=js&"
import style0 from "./marketingReason.vue?vue&type=style&index=0&id=7d28569e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d28569e",
  null
  
)

component.options.__file = "marketingReason.vue"
export default component.exports